<template>
  <v-dialog
    v-model="dialog"
    width="900"
    scrollable
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-card-title>
        {{ __("agendamento") }}
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- <v-toolbar flat elevation="0">
        <v-spacer></v-spacer>
        <v-btn color="primary" text> Agendar </v-btn>
      </v-toolbar> -->
      <v-divider></v-divider>

      <v-card-text class="pt-5" style="background-color: #f1f1f1">
        <v-row>
          <v-col>
            <v-card style="min-height: 100%">
              <v-card-subtitle> {{ __("agendamento") }} </v-card-subtitle>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Tipo") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.scheduling_type.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Status") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      <SchedulingStatusChip :status="scheduling.status" label />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Data de início") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ `${scheduling.created_at}` }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="scheduling.expires_at">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("prazo para contacto") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{
                        scheduling.expires_at +
                        " (" +
                        scheduling.expires_at_diff +
                        ")"
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("data da marcação") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.scheduled_at || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("duração") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{
                        scheduling.scheduling_duration !== null
                          ? `${scheduling.scheduling_duration}h`
                          : "---"
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col>
            <v-card style="min-height: 100%">
              <v-card-subtitle> {{ __("marcação") }} </v-card-subtitle>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("data marcada") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{
                        scheduling.date
                          ? `${scheduling.date} ${scheduling.time}`
                          : "---"
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="scheduling.expected_end_date">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Data prevista para finalização") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.expected_end_date || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("responsável pela marcação") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.scheduled_by?.name || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="scheduling.canceled_by">
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("responsável pelo cancelamento") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.canceled_by.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Justificativa de atraso") }}
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-wrap">
                      {{ scheduling.delay_justification || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("Justificativa") }}
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-wrap">
                      {{ scheduling.justification_description || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("detalhes da justificativa") }}
                    </v-list-item-subtitle>
                    <v-list-item-title class="text-wrap">
                      {{ scheduling.justification_message || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-subtitle>
                {{ __("tentativas de contacto") }}
              </v-card-subtitle>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ __("próxima tentativa de contacto") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ scheduling.next_attempt_at || "---" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-for="attempt in scheduling.attempts"
                  :key="attempt.id"
                  three-line
                >
                  <v-list-item-icon>
                    <v-icon
                      v-if="attempt.success && attempt.successful_scheduling"
                      color="green"
                      title="Agendamento bem sucedido"
                    >
                      mdi-phone-check
                    </v-icon>
                    <v-icon
                      v-else-if="attempt.success"
                      color="warning"
                      title="Contacto sem agendamento"
                    >
                      mdi-phone-alert
                    </v-icon>
                    <v-icon v-else title="Insucesso ao contactar" color="error">
                      mdi-phone-cancel
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ attempt.order }}ª {{ __(" tentativa de contacto") }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ attempt.date_formatted }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Justificativa: {{ attempt.justification?.name || "---" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      class="ml-2"
                      @click="openEdit(attempt)"
                      color="primary"
                      small
                      outlined
                    >
                      {{ __("alterar") }}
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="scheduling.attempts.length < 1">
                  <v-list-item-content>
                    <v-list-item-title class="grey--text caption">
                      Nenhuma tentativa de contacto registada
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <EditAttemptDateDialog
        ref="open_dialog"
        :title="title_edit"
        :date="date_attempt"
        :scheduling="scheduling"
        :attempt="attempt"
        @reload="reload"
      ></EditAttemptDateDialog>
    </v-card>
  </v-dialog>
</template>

<script>
import EditAttemptDateDialog from "./EditAttemptDateDialog.vue";
import SchedulingStatusChip from "./SchedulingStatusChip.vue";
import i18n from "@/mixins/i18n";
import { useContactAttempts } from "@/constants/ContactAttempts";

export default {
  name: "LeadschedulingDialog",
  mixins: [i18n],
  components: {
    SchedulingStatusChip,
    EditAttemptDateDialog,
  },

  data() {
    return {
      i18n_prefix: "schedulings",
      dialog: false,
      scheduling: null,
      title_edit: "",
      date_attempt: "",
      attempt: "",
      attempts: useContactAttempts(),
      loading: false,
      first_attempt_at_contact: this.__(
        "1ª tentativa de contacto",
        "schedulings"
      ),
      second_attempt_at_contact: this.__(
        "2ª tentativa de contacto",
        "schedulings"
      ),
      third_attempt_at_contact: this.__(
        "3ª tentativa de contacto",
        "schedulings"
      ),
    };
  },

  props: {
    lead_identifier_code: String,
  },

  methods: {
    setScheduling(scheduling) {
      this.scheduling = scheduling;
    },

    open(scheduling) {
      this.setScheduling(scheduling);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    openEdit(attempt) {
      this.$refs.open_dialog.open(attempt);
    },

    reload(leadScheduling) {
      this.$emit("reload", leadScheduling);
      this.setScheduling(leadScheduling);
    },
  },
};
</script>
